import { PALETTE, FONT_DISPLAY, FONT_MONO } from "@/components/cobrain/tokens";

/* Horizontal timeline for "How an AI implementation actually runs".
   Makes the speed claim visible rather than merely stated. */

const STEPS = [
  { when: "Day 0", n: "01", t: "Get on a call", b: "Fifteen minutes with an engineer, not a salesperson. We work out whether there's real money in this for you." },
  { when: "Days 2–5", n: "02", t: "Audit & plan", b: "We map your operation and hand you a prioritised plan of what to automate first, second, and never." },
  { when: "Week 1", n: "03", t: "First workflow live", b: "One real thing running in your business before we talk about the next one." },
  { when: "Ongoing", n: "04", t: "Build, train, or run", b: "We implement the rest, teach your team to run it, or operate it for you. Your call." },
];

export function ServiceTimeline() {
  return (
    <div className="svc-timeline" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 18 }}>
      {STEPS.map((s, i) => (
        <div key={s.n} style={{ position: "relative", paddingTop: 30 }}>
          {/* rail */}
          <span aria-hidden className="svc-tl-rail" style={{
            position: "absolute", top: 9, left: 0, right: i === STEPS.length - 1 ? "50%" : -18,
            height: 2, background: `linear-gradient(90deg, ${PALETTE.amber} 0%, rgba(196,130,58,0.28) 100%)`,
          }} />
          <span aria-hidden className="svc-tl-dot" style={{
            position: "absolute", top: 3, left: 0, width: 14, height: 14, borderRadius: "50%",
            background: PALETTE.amber, boxShadow: `0 0 0 4px ${PALETTE.bg}`,
          }} />
          <div style={{ fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: "0.14em", textTransform: "uppercase", color: PALETTE.amber, fontWeight: 700, marginBottom: 8 }}>
            {s.when}
          </div>
          <h3 style={{ fontFamily: FONT_DISPLAY, fontWeight: 400, fontSize: 23, margin: "0 0 8px", letterSpacing: "-0.01em" }}>{s.t}</h3>
          <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.55, color: PALETTE.ink2 }}>{s.b}</p>
        </div>
      ))}
      <style>{`
        @media (max-width: 900px) {
          .svc-timeline { grid-template-columns: 1fr !important; gap: 0 !important; }
          .svc-timeline > div { padding: 0 0 26px 26px !important; }
          .svc-tl-rail { top: 14px !important; left: 6px !important; right: auto !important; width: 2px; height: 100% !important; background: linear-gradient(180deg, ${PALETTE.amber} 0%, rgba(196,130,58,0.22) 100%) !important; }
          .svc-timeline > div:last-child .svc-tl-rail { display: none; }
          .svc-tl-dot { top: 4px !important; }
        }
      `}</style>
    </div>
  );
}

export default ServiceTimeline;
